import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const PaywallContext = createContext(null);

export function PaywallProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");

  const show = useCallback((message) => {
    setReason(message || "Votre période d'essai est expirée. Passez à Athlynx Pro pour continuer.");
    setOpen(true);
  }, []);

  const hide = useCallback(() => setOpen(false), []);

  const value = useMemo(() => ({ open, reason, show, hide }), [open, reason, show, hide]);
  return <PaywallContext.Provider value={value}>{children}</PaywallContext.Provider>;
}

export function usePaywall() {
  const ctx = useContext(PaywallContext);
  if (!ctx) throw new Error("usePaywall must be used within PaywallProvider");
  return ctx;
}
